import { useCallback, useContext } from 'react';
import { WidgetEnvironmentContext } from '../EnvironmentProvider';
import { ModalContext } from './ModalContext';
export function useModal(modalName, options) {
    var modalContext = useContext(ModalContext);
    var environment = useContext(WidgetEnvironmentContext);
    if (!environment) {
        throw new Error("`useModal()` can't be used within a `Editor panel`. Please use `usePanel()`");
    }
    var openModal = useCallback(function (overrideOptions) {
        modalContext.openModal(modalName, overrideOptions !== null && overrideOptions !== void 0 ? overrideOptions : options);
    }, [modalContext.openModal, modalName]);
    return { openModal: openModal };
}
//# sourceMappingURL=useModal.js.map